import API from '../utilities/API'

class Auth {
  attemptSignIn ({ email, password }) {
    return new Promise((resolve, reject) => {
      API.post({ url: 'login', data: { 'emailAddress': email, 'password': password } })
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(response => {
          reject(response)
        })
    })
  }

  attemptToSetPassword ({ password, token }) {
    return new Promise((resolve, reject) => {
      API.post({ url: 'setPassword', data: { password, 'verificationToken': token } })
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(response => {
          reject(response)
        })
    })
  }

  attemptToVerifyAccount ({ token }) {
    return new Promise((resolve, reject) => {
      API.post({ url: 'verifyAccount', data: { verificationToken: token } })
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        }).catch(response => {
          reject(response)
        })
    })
  }

  requestPasswordReset ({ email }) {
    return new Promise((resolve, reject) => {
      API.post({ url: 'requestPasswordReset', data: { 'emailAddress': email } })
        .then(response => {
          if (response.SUCCESS) {
            return resolve(response)
          } else {
            return reject(response)
          }
        })
        .catch(response => {
          return reject(response)
        })
    })
  }

  resetPassword ({ token, password }) {
    return new Promise((resolve, reject) => {
      API.post({ url: 'setPassword', data: { 'verificationToken': token, password } })
        .then(response => {
          if (response.SUCCESS) {
            return resolve(response)
          } else {
            return reject(response)
          }
        })
        .catch(response => {
          return reject(response)
        })
    })
  }

  verifyAccount ({ token }) {
    return new Promise((resolve, reject) => {
      API.post({url: 'verifyAccount', data: { token }})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }
}

export default new Auth()



// WEBPACK FOOTER //
// ./src/api/services/auth.js